import React from "react";
//import { useRef} from "react";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {makeStyles} from '@mui/styles';
import { /*BrowserRouter as Router,*/useHistory, Route} from "react-router-dom";
import ProjectsNav from "../components/ProjectsNav";
// import {SotsMedia, SotsDesc, 
//         zcMedia, zcDesc,
//         harMedia, harDesc,
//         assessmentMedia, assessmentDesc,
//         testVidsDesc, testVidsMedia,
//         sbnDesc, sbnMedia,
//         ssDesc, ssMedia,
//         tdDesc, tdMedia,
//         bcDesc, bcMedia} 
// from '../ProjectData'
import { projectsList } from "../ProjectData";
import {globalTheme} from "../components/Theme"
import ProjectRoute from "../components/ProjectRoute";
// import ScrollToTopButton from "../components/ScrollToTopButton";
// import ScrollToProject from "../components/ScrollToProject";

const useStyles = makeStyles((theme) => ({
    content: {
        marginTop: theme.spacing(3),
        zIndex: -1,
        backgroundColor: "rgba(23, 26, 33, 0.8)",
        width: "90%",
        marginLeft: "5%",
    },
    header:{
        fontWeight: 600,
        padding: theme.spacing(3)
    },
    contentGrid: {
        width: "100%"
    },
    gridItem: {
        width: "100%",
    }
}));

export default function Projects(){
    const classes = useStyles();
    const history = useHistory();

    const changeRoute = (projectInfo, i) => {
        history.push(projectInfo.route + "/" + projectInfo.list[i][0].key);
    }

    return (
        (<div>
            <Typography variant="h2" align="center" className={"text " + classes.header} style={globalTheme.palette.heading}>PROJECTS</Typography>
            <div className={"project-nav " + classes.content}>
                <ProjectsNav projectsList={projectsList} />
            </div>
            {/* <ScrollToTopButton /> */}
            <div className="project-content">
                <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    className={classes.contentGrid}
                >
                    {/*<Router>*/}
                        <Grid item className={classes.gridItem}>
                            {
                                projectsList.map(
                                    (projectList) => (
                                        <Route path={projectList.route} key={projectList.title}>
                                            <ProjectRoute 
                                                projectsInfo={projectList} 
                                                changeRoute={changeRoute}
                                                />
                                        </Route>
                                    )
                                )
                            }
                        </Grid>
                </Grid>
            </div>
        </div>)
    );
}